export default __webpack_public_path__ + "static/media/avatar_tiger5.48f85b5d.mp3";